import { render } from "./AdvtgListUsados.vue?vue&type=template&id=0896702c"
import script from "./AdvtgListUsados.vue?vue&type=script&lang=js"
export * from "./AdvtgListUsados.vue?vue&type=script&lang=js"

import "./AdvtgListUsados.vue?vue&type=style&index=0&id=0896702c&lang=scss"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__